import { FC } from 'react';

import { ChipChoice } from '@telialt/common-chip-choice/src';

import { BadgeComponentProps } from '../model';

export const TextBadge: FC<BadgeComponentProps & { name: string }> = ({
    dataTest,
    checked,
    disabled,
    disabledLooking,
    onClick,
    children,
    parentUID = '',
    name,
}) => (
    <ChipChoice
        checked={checked}
        disabled={disabled}
        unavailable={disabledLooking ? 'Išparduota' : undefined}
        onChange={onClick}
        name={name + parentUID}
        data-test={dataTest}
    >
        {children}
    </ChipChoice>
);
